import request from '@/utils/request'

// 产品分类
export function productType(params) {
  return request({
    url:'/Product.ProductType/index',
    method:'get',
    params:params
  })
}

// 品牌
export function brandList(params) {
  return request({
    url:'/Product.Brand/index',
    method:'get',
    params:params
  })
}

// 产品组
export function division(params) {
  return request({
    url:'/Sap.Division/index',
    method:'get',
    params:params
  })
}

// 物料分类
export function sappType(params) {
  return request({
    url:'/Sap.SappType/index',
    method:'get',
    params:params
  })
}

// 产品列表
export function productList(data) {
  return request({
    url:'/Product.Product/index',
    method:'post',
    data:data
  })
}

// 产品详情
export function productDetail(params) {
  return request({
    url:'/Product.Product/view',
    method:'get',
    params:params
  })
}

// 添加产品到购物车
export function addcart(params) {
  return request({
    url:'/Crm.Cart/addcart',
    method:'get',
    params:params
  })
}

// VIN识图
export function VinOcr(data) {
  return request({
    url:'Vin/ocr',
    method:'post',
    data:data
  })
}



// 分配库存
export function deliveryAllocateinventory(data) {
  return request({
    url:'/Crm.Delivery/deliveryAllocateinventory',
    method:'post',
    data:data
  })
}
// 获取产品价格
export function getallprice(params) {
  return request({
    url:'/Product.Price/getallprice',
    method:'get',
    params:params
  })
}


// 通过车架号获取车型信息
export function VinCarinfo(data) {
  return request({
    url:'Shop.Vin/carinfo',
    method:'post',
    data:data
  })
}
// 通过车架号查产品
export function VinSearchProduct(data) {
  return request({
    url:'Crm.Vin/searchproduct',
    method:'post',
    data:data
  })
}
// 车架号识别
export function VinOcrNew(data) {
  return request({
    url:'Shop.Vin/ocr',
    method:'post',
    data:data
  })
}
// 获得热门搜索关键字
export function gethotlist(params) {
  return request({
    url:'Shop.Vin/gethotlist',
    method:'get',
    params:params
  })
}
// 通过OE号查询ETK及EPC内容
export function getbyoe(data) {
  return request({
    url:'Shop.Vin/getbyoe',
    method:'post',
    data:data
  })
}

// 提问列表
/* export function getQuestion(params) {
  return request({
    url: 'Shop.RelatedQuestion/getList',
    method: 'get',
    params: params
  })
} */
export function getQuestion(params) {
  return request({
    url: 'Product.Product/crmList',
    method: 'get',
    params: params
  })
}
// 提问
// export function addQuestion(params) {
//   return request({
//     url:'Shop.RelatedQuestion/add',
//     method:'get',
//     params:params
//   })
// }
// 提问
/* export function addQuestion(data) {
  return request({
    url: 'Shop.RelatedQuestion/add',
    method: 'post',
    data: data
  })
} */
  export function addQuestion(data) {
    return request({
      url: 'Shop.RelatedQuestion/crmadd',
      method: 'post',
      data: data
    })
  }
// 回复
export function replyUp(data) {
  return request({
    url: 'Shop.RelatedQuestion/update',
    method: 'post',
    data: data
  })
}

// 获取经销商
export function getAllDoyorStock(params) {
  return request({
    url: 'Product.Product/getAllDoyorStock',
    method: 'get',
    params: params
  })
}

// 导出excel
export function ProductListExport(data) {
  return request({
    url:'/Product.Product/ProductListExport',
    method: 'post',
    data: data,
    responseType: "blob"
  })
}

// 定时同步图片
export function SynchronizePictures(data) {
  return request({
    url:'/Crm.StatisticalFunction/SynchronizePictures',
    method: 'post',
    data: data,
  })
}

//产品一年月份销售统计
export function productYearSalesHistory(data) {
  return request({
    url:'/Product.Product/productYearSalesHistory',
    method: 'post',
    data: data,
  })
}

//产品一年月份退货统计
export function productYearReturnHistory(data) {
  return request({
    url:'/Product.Product/productMonthReturn',
    method: 'post',
    data: data,
  })
}

//oe搜索记录汇总
export function oeSummaryLog(data) {
  return request({
    url: '/Product.Product/oeSummaryLog',
    method: 'post',
    data
  })
}

//oe搜索记录
export function oeSearchLog(data) {
  return request({
    url: '/Product.Product/oeSearchLog',
    method: 'post',
    data
  })
}

//导出oe搜索记录
export function oeSearchLogExport(data) {
  return request({
    url: '/Product.Product/oeSearchLogExport',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js